import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight, Quote } from "lucide-react";
import { CASES } from "@/data/cases";
import { reachGoal } from "@/lib/metrika";

export function CasesGrid({ limit }: { limit?: number }) {
  const list = limit ? CASES.slice(0, limit) : CASES;
  return (
    <section
      id="cases"
      aria-labelledby="cases-title"
      className="mx-auto mt-20 w-full max-w-6xl px-4"
    >
      <div className="mb-8 text-center">
        <p className="mb-2 text-xs font-bold uppercase tracking-[0.25em] text-primary">Кейсы</p>
        <h2 id="cases-title" className="text-2xl font-extrabold tracking-tight text-foreground sm:text-3xl md:text-4xl">
          Реальные результаты клиентов
        </h2>
        <p className="mx-auto mt-3 max-w-2xl text-sm text-muted-foreground sm:text-base">
          Цифры за последние 12 месяцев. Имена и должности — реальные, можем дать контакт для проверки.
        </p>
      </div>

      <div className="grid gap-5 md:grid-cols-3">
        {list.map((c, i) => (
          <motion.article
            key={c.slug}
            initial={{ opacity: 0, y: 16 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            transition={{ delay: i * 0.08, duration: 0.4 }}
            onViewportEnter={() => reachGoal("case_view")}
            className="glass-card flex flex-col p-5"
          >
            <div className="mb-2 text-[10px] font-bold uppercase tracking-widest text-muted-foreground">
              {c.industry}
            </div>
            <h3 className="mb-3 text-base font-bold text-foreground">{c.client}</h3>
            <p className="mb-4 text-xs leading-relaxed text-muted-foreground">{c.challenge}</p>

            <div className="mb-4 grid grid-cols-3 gap-2 rounded-xl border border-border/40 bg-secondary/20 p-3">
              {c.metrics.map((m) => (
                <div key={m.label} className="text-center">
                  <p className="text-sm font-extrabold text-primary sm:text-base">{m.value}</p>
                  <p className="mt-0.5 text-[9px] uppercase tracking-wide text-muted-foreground">{m.label}</p>
                </div>
              ))}
            </div>

            <div className="mt-auto rounded-xl bg-primary/5 p-3">
              <Quote className="mb-1 h-3 w-3 text-primary/60" />
              <p className="mb-2 text-xs italic text-foreground/90">«{c.quote}»</p>
              <p className="text-[11px] font-semibold text-foreground">{c.author}</p>
              <p className="text-[10px] text-muted-foreground">{c.role}</p>
            </div>
          </motion.article>
        ))}
      </div>

      {limit && (
        <div className="mt-8 text-center">
          <Link to="/cases" className="inline-flex items-center gap-2 text-sm font-semibold text-primary hover:underline">
            Все кейсы <ArrowRight className="h-4 w-4" />
          </Link>
        </div>
      )}
    </section>
  );
}
